import React from "react";
import { useIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import { Tupel } from "components";
import { TVehicle } from "types";

import Zusatzleistungen from "./Zusatzleistungen";
import BankInfo from "./BankInfo";

interface IDetail {
  vehicle: TVehicle;
  financeRate?: any;
  short?: boolean;
}

const Leasing: React.FC<IDetail> = ({
  financeRate,
  vehicle,
  short = false,
}): JSX.Element => {
  const {
    rate,
    downPayment,
    runtime,
    bank,
    borrowingRate,
    apr,
    mileage,
    moreKm,
    lessKm,
  } = financeRate;

  const { preis_fracht_vk_brutto } = vehicle;
  const has_fracht: boolean = !!(
    preis_fracht_vk_brutto && preis_fracht_vk_brutto > 0
  );
  const vatInformation =
    financeRate.customerType === "business"
      ? "netto zuzüglich MwSt., nur für Gewerbekunden"
      : "inkl. MwSt.";
  const { formatMessage: t } = useIntl();
  return (
    <Box>
      <Tupel
        labelId="page.detail.finance.detail.rate"
        label="Monatliche Rate"
        euro={rate}
        boxProps={{ fontWeight: "bold" }}
        digits={2}
        information={vatInformation}
        informationPosition="right"
      />

      <Zusatzleistungen financeRate={financeRate} />
      <Tupel
        labelId="common.type"
        textId={
          "filter.financial.v2.rateType.options." + financeRate.type + ".label"
        }
        text={
          financeRate.type === "leasingbusiness"
            ? "gewerbliches Leasing"
            : "Leasing"
        }
      />
      {has_fracht && (
        <Tupel
          label="Zuzüglich Überführungskosten (einmalig)"
          labelId="page.detail.finance.detail.rateWithTransport"
          euro={preis_fracht_vk_brutto}
          boxProps={{ fontWeight: "bold" }}
          digits={2}
        />
      )}
      {!short && (
        <>
          <Tupel
            labelId="filter.financial.downPayment.title.label"
            force
            euro={downPayment}
            digits={2}
          />
          <Tupel
            labelId="common.contractRuntime"
            number={runtime}
            unit={t({ id: "common.months" })}
          />
          <Tupel labelId="common.mileage" number={mileage} unit="km" />
          {/* <Tupel
            labelId={has_fracht ? "filter.financial.total-mit-fracht.label" : "filter.financial.total.label"}
            digits={2}
            boxProps={{ fontWeight: "bold" }}
            euro={total + preis_fracht_vk_brutto}
          /> */}
          <Tupel
            labelId="filter.financial.apr.label"
            digits={2}
            percent={apr / 100}
          />
          <Tupel
            labelId="filter.financial.borrowingRate.label"
            digits={2}
            percent={borrowingRate / 100}
          />
          <Tupel
            labelId="filter.financial.moreKm.label"
            digits={2}
            euro={moreKm}
          />
          <Tupel
            labelId="filter.financial.lessKm.label"
            digits={2}
            euro={lessKm}
          />
          <BankInfo bank={bank} />
          {bank.legalTextLoan?.length > 1 && (
            <Typography
              variant="body1"
              sx={{ px: 1, backgroundColor: "grey.50" }}
            >
              {bank.legalTextLoan}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default Leasing;
